module.exports = __webpack_public_path__ + "static/media/pathogenic_detail.eec5b62a.png";